import { render, staticRenderFns } from "./sousuo.vue?vue&type=template&id=702ca284&scoped=true"
import script from "./sousuo.vue?vue&type=script&lang=js"
export * from "./sousuo.vue?vue&type=script&lang=js"
import style0 from "./sousuo.vue?vue&type=style&index=0&id=702ca284&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702ca284",
  null
  
)

export default component.exports